/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   HeaderMobileStr
 */

import { HamburgerCloseButton } from '@zcode-ui/controls'
import { Search, ZumperFullDark } from '@zcode-ui/icons'
import { Button, cn } from '@zcode-ui/shadz-ui'
import { isDetailPageNew } from '@zcode-ui/web-zumper-global-state'
import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import type { PassedHeaderProps } from '../../../types'
import { DetailNavbarBackBtn } from '../../DetailNavbarBackBtn/DetailNavbarBackBtn'
import { SaveSearchButtonMobileContainer } from '../../SaveSearchButton'

interface HeaderMobileDetailPageProps {
  handleHamburgerClick: () => void
}

export const HeaderMobileDetailPage = ({
  dispatchCreateSearch,
  dispatchRemoveSavedSearch,
  handleHamburgerClick,
  isDetailView,
  isStatic,
  onSaveSearchModalOpen,
  onSearchButtonClick,
  url,
}: HeaderMobileDetailPageProps &
  Pick<
    PassedHeaderProps,
    | 'dispatchCreateSearch'
    | 'dispatchRemoveSavedSearch'
    | 'isDetailView'
    | 'isStatic'
    | 'onSaveSearchModalOpen'
    | 'url'
    | 'onSearchButtonClick'
  >) => {
  const isNewDetailPage = useSelector(isDetailPageNew)

  return (
    <nav
      className={cn(
        'fixed top-0 right-0 left-0 h-[calc(1px*var(--header-height))] bg-gray-50 border-b border-solid border-gray-150 z-[1030] py-0 px-6',
        isStatic && 'static'
      )}
    >
      <div className="flex justify-between items-center h-16 pt-3 flex-row">
        <Fragment>
          {isNewDetailPage ? (
            <DetailNavbarBackBtn isDetailView={isDetailView} />
          ) : (
            <SaveSearchButtonMobileContainer
              dispatchCreateSearch={dispatchCreateSearch}
              dispatchRemoveSavedSearch={dispatchRemoveSavedSearch}
              isMobile
              onSaveSearchModalOpen={onSaveSearchModalOpen}
              origin={`f-popup-${url ?? ''}`}
            />
          )}
        </Fragment>

        <a
          aria-label="Zumper"
          href="/"
          className="block h-[34px] absolute right-1/2 translate-x-1/2"
        >
          <ZumperFullDark size={34} />
        </a>

        <div className="flex">
          <Button
            aria-label="search"
            className="h-5 min-w-5 p-0"
            id="detail-autocomplete-search-icon"
            onClick={onSearchButtonClick}
            variant="ghost"
          >
            <Search fill="#0a0f1c" size={16} />
          </Button>

          <div className="border-r border-solid border-gray-150 mx-2" />
          <HamburgerCloseButton
            aria-label={'open side menu'}
            color="#0a0f1c"
            onClick={handleHamburgerClick}
          />
        </div>
      </div>
    </nav>
  )
}
